/**
 * Toast « Rappels réactivés » — confirmation visuelle affichée après la
 * réouverture d'un élément (tâche ou document) via le bouton « Rouvrir ».
 *
 * Spec iter134 (Feb 2026) — Le module de rappels applique une coupure
 * conditionnelle : dès qu'un élément passe à un statut clôturé, plus
 * aucune notification automatique n'est émise. Quand l'utilisateur
 * ré-ouvre l'élément, les rappels reprennent automatiquement au tick
 * suivant du scheduler. Ce toast rassure l'utilisateur en confirmant
 * cette reprise.
 *
 * Style aligné sur les autres toasts sonner de l'app (`toast.success`).
 * L'icône est une cloche verte (Bell) sourcée depuis lucide-react.
 */
import { Bell } from "lucide-react";
import { toast } from "@/lib/toast";

export function toastRappelsReactivated() {
  toast.success("Rappels réactivés", {
    description: "Les notifications reprendront normalement pour cet élément",
    icon: (
      <div
        className="inline-flex items-center justify-center rounded-full"
        style={{
          width: 22,
          height: 22,
          background: "rgba(34,197,94,0.18)",
          color: "#4ADE80",
        }}
        aria-hidden="true"
      >
        <Bell size={13} strokeWidth={2.4} />
      </div>
    ),
    duration: 4000,
    // data-testid pour l'automation testing (spec iter134).
    // sonner ne l'expose pas directement — on l'ajoute via unstyled: false
    // et un className unique.
    className: "toast-rappels-reactives",
  });
}
